module.exports = __webpack_public_path__ + "img/w3_technical_white.9d1a942c.png";